import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import LanguageSwitcher from '../components/LanguageSwitcher';
import Footer from '../components/Footer';
import './StaticPages.css';

const CancellationPage = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="static-page">
      <header className="header">
        <div className="container">
          <div className="logo">
            <span className="logo-icon">🏍️</span>
            <h1>ThaiBike Rent</h1>
          </div>
          <div className="header-right">
            <LanguageSwitcher />
            <div className="contact-header">
              <a href="tel:+66123456789" className="phone">+66 123 456 789</a>
            </div>
          </div>
        </div>
      </header>

      <div className="container static-content">
        <div className="page-header">
          <h1>{t.pageCancellation}</h1>
          <p className="effective-date">{t.cancellationEffective}</p>
        </div>

        <div className="content-section">
          <h2>{t.cancellationTitle}</h2>
          <p className="intro">{t.cancellationIntro}</p>
        </div>

        <div className="content-section">
          <h3>{t.cancellationSection1}</h3>
          <p>{t.cancellationContent1}</p>
        </div>

        <div className="content-section">
          <h3>{t.cancellationSection2}</h3>
          <p>{t.cancellationContent2}</p>
        </div>

        <div className="content-section">
          <h3>{t.cancellationSection3}</h3>
          <p>{t.cancellationContent3}</p>
        </div>

        <div className="content-section">
          <h3>{t.cancellationSection4}</h3>
          <p>{t.cancellationContent4}</p>
        </div>

        <div className="content-section">
          <h3>{t.cancellationSection5}</h3>
          <p>{t.cancellationContent5}</p>
        </div>

        <div className="back-home">
          <a href="/" className="btn btn-outline">← Back to Home</a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CancellationPage;